module.exports = __webpack_public_path__ + "static/media/herald-logo@3x.b5e38b5d.jpg";